export const formatBedDisplayName = (
  bedName?: string | null,
  anchorCode?: string | null,
  fallbackId?: string | number | null,
): string => {
  const custom = typeof bedName === 'string' ? bedName.trim() : '';
  const anchor = typeof anchorCode === 'string' ? anchorCode.trim() : '';

  if (custom && anchor) {
    // Не дублируем дефолтный формат, если имя не меняли.
    if (custom === `Грядка ${anchor}` || custom === anchor) {
      return `Грядка ${anchor}`;
    }
    return `${custom} [${anchor}]`;
  }

  if (custom) return custom;
  if (anchor) return `Грядка ${anchor}`;

  if (fallbackId !== undefined && fallbackId !== null) {
    return `Грядка #${String(fallbackId).slice(0, 8)}`;
  }

  return 'Грядка —';
};
